<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Inquiry Faktur</h5>
            </template>
            <DetailGadaiKomp :detailGadai="dataDetailPembayaran" :isShowEditImei="true" />
            <div class="detail-edit-btn">
                <b-button variant="pgiBtn" v-if="dataDetailPembayaran.statusGadai == 'Berjalan' && allowedEdit == 1" class="mr-2" name="gadaiEditBtn" @click="editGadai">Edit</b-button>
                <b-button variant="pgiBtn" name="checkHistoryBtn" @click="checkHistory">Histori Data Gadai</b-button>
            </div>
        </b-card>
    </div>
</template>

<script>

import DetailGadaiKomp from '../../../components/gadai/DetailGadaiKomp'

export default {
    name: 'detail-pembayaran',
    components: {
        DetailGadaiKomp
    },
    data(){
        return {
            cabangId: '',
            noFaktur: null,
            initStatus: 0,
            cabangId: null,
            dataDetailPembayaran: {},
            statusGadai: null,
            allowedEdit: 0

        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.noFaktur = this.$route.params.id
            this.cabangId = this.$helper.getCabangId()

            let getSinglePembayaran = this.$axios.get(`gadai/detail/faktur/${this.noFaktur}`).then(response => {
                this.dataDetailPembayaran = response.data
                if(response.data.id != null){
                    this.$axios.get(`gadai/daftar-gadai/${response.data.id}/status`).then(response => {
                        this.statusGadai = response.data.id
                    })
                }
            })

            let getAllowedEdit = this.$axios.get("gadai/edit-allowed").then(response => {
                this.allowedEdit = response.data.id
            })
            
            Promise.all([getSinglePembayaran, getAllowedEdit]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        editGadai(){
        
            if ( this.dataDetailPembayaran.barang.jenisPinjaman.id == 1 ) {
                if(this.statusGadai !=0){
					this.$router.push({path: `${this.$route.path}/elek-staging/${this.dataDetailPembayaran.id}`});
				}else{
					this.$router.push({path: `${this.$route.path}/elektronik/${this.dataDetailPembayaran.id}`});
				}
            }

            if ( this.dataDetailPembayaran.barang.jenisPinjaman.id == 2 ) {
                if(this.statusGadai !=0){
                    this.$router.push({path: `${this.$route.path}/kend-staging/${this.dataDetailPembayaran.id}`});
                }else{
                    this.$router.push({path: `${this.$route.path}/kendaraan/${this.dataDetailPembayaran.id}`});
                }
            }

            if ( this.dataDetailPembayaran.barang.jenisPinjaman.id == 3 ) {
                if(this.statusGadai !=0){
					this.$router.push({path: `${this.$route.path}/emas-staging/${this.dataDetailPembayaran.id}`});
				}else{
					this.$router.push({path: `${this.$route.path}/emas/${this.dataDetailPembayaran.id}`});
				}
            }
        },

        checkHistory(){
            this.$router.push({
                path: `${this.$route.path}/detail-history-gadai`
            })
        },
    },

    created(){
        this.init()
    }
}
</script>
